import { useEffect, useState } from "react";

/**
 * Hook to detect the user's device type based on user agent
 * @returns Current device type ('ios', 'android', or 'desktop')
 */
export const useDeviceDetection = () => {
  const [deviceType, setDeviceType] = useState<"ios" | "android" | "desktop">(
    "desktop",
  );

  useEffect(() => {
    // Define Window with opera property
    interface WindowWithOpera extends Window {
      opera?: unknown;
      MSStream?: unknown;
    }

    const userAgent =
      navigator.userAgent ||
      navigator.vendor ||
      ((window as WindowWithOpera).opera as string) ||
      "";

    // iOS detection
    if (
      /iPad|iPhone|iPod/.test(userAgent) &&
      !(window as WindowWithOpera).MSStream
    ) {
      setDeviceType("ios");
      return;
    }

    // Android detection
    if (/android/i.test(userAgent)) {
      setDeviceType("android");
      return;
    }

    // Default to desktop
    setDeviceType("desktop");
  }, []);

  return deviceType;
};

export default useDeviceDetection;
